import { render, staticRenderFns } from "./r-radio-group.vue?vue&type=template&id=772af2ac&scoped=true"
import script from "./r-radio-group.vue?vue&type=script&lang=js"
export * from "./r-radio-group.vue?vue&type=script&lang=js"
import style0 from "./r-radio-group.vue?vue&type=style&index=0&id=772af2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772af2ac",
  null
  
)

export default component.exports